import { useEffect, useRef, useState } from "react";
import {
  logo,
  dataLoading,
  Download,
  Earn,
  exports,
  Send,
  Tree,
  view,
} from "../../assets/assets";
import httpApiCall from "../../service/api.service";
import { getStorageValue } from "../../service/shared.service";
import Tier from "../Calculator/Tier";
import "./Commissions.scss";
import Dropdown from "react-bootstrap/Dropdown";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import Table from "../elements/tableComponent";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import { formatDate, formatDate2 } from "../../utils/DateFormat";
import Pagination from "../../utils/Pagination";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import NoDataFound from "../NoDataFound/NoDataFound";
import { Button, Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Commissions = () => {
  const allData = getStorageValue("partnerData");
  const dataArray = [
    ["Sr.	", "Tier","Business Name", "Business Code","Contract Code","Payment Type", "Transaction Date", "Commission Amount (" + allData.country_currency_info.currency[0]['display_logo'] + ')']
  ];
  const columns = [
    { title: "S.NO", dataKey: "sno" },
    { title: "Tier", dataKey: "tier" },
    { title: "Business Name", dataKey: "businessName" },
    { title: "Business Code", dataKey: "businessCode" },
    { title: "Contract Code", dataKey: "contractCode" },
    { title: "Payment Type", dataKey: "paymentType" },
    { title: "Transaction Date", dataKey: "transactionDate" },
    { title: "Commission Amount (" + allData.country_currency_info.currency[0]['display_logo'] + ')', dataKey: "amount" },
  ];
  const filter = [
    {
      id: 0,
      name: "This Month",
    },
    {
      id: 1,
      name: "Last 3 Months",
    },
    {
      id: 2,
      name: "Last 6 Months",
    },
    {
      id: 3,
      name: "Custom Range",
    },
    {
      id: 4,
      name: "Till Now",
    },
  ];
  const [state, setState] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const [selectedChoice, setSelectedChoice] = useState({
    name: "Till Now",
    id: "4",
  });
  const csvLinkRef = useRef<any>(null);
  const [show, setShow] = useState(false);
  const [payOut, setPayOut] = useState();
  const [page, setPage] = useState(1);
  const [listData, setListData] = useState<any>([]);
  const [docsdata, setDocsData] = useState<any>([]);
  const [records, setRecords] = useState([]);
  const [open, setOpen] = useState(false);
  const [grid, setGrid] = useState(false);
  const [shimmer, setShimmer] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [startOfMonth, setStartOfMonth] = useState(
    new Date("2017-01-01")
  );
  const partnerData = getStorageValue("partnerProfile");
  const paymentData =getStorageValue("paymentData");
  

  useEffect(() => {
    getCommisions();
    const savedGridView = localStorage.getItem('commissionGridView');
    if (savedGridView !== null) {
      setGrid(savedGridView === 'true');
    }
  }, []);

  useEffect(() => {
    if (!grid) {
      getCommisions();
    }
    getListCommissions();
  }, [startOfMonth, currentDate]);

  const handleChoiceSelection = (item: any) => {
    setSelectedChoice(item);
    // console.log(item, "item selected");
    getStartOfMonth(item.id, new Date());
  };

  const getStartOfMonth = (date: any, currentDate: Date) => {
    setOpen(false);
    if (date === 0) {
      const startOfMonthDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      setStartOfMonth(startOfMonthDate);
    } else if (date === 1) {
      const threeMonthsAgo = new Date(currentDate);
      threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
      setStartOfMonth(threeMonthsAgo);
    } else if (date === 2) {
      const sixMonthsAgo = new Date(currentDate);
      sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
      setStartOfMonth(sixMonthsAgo);
    } else if (date === 3) {
      setOpen(true);
      setShow(true);
    } else if (date === 4) {
      const tillNow = new Date("2017-01-01");
      setStartOfMonth(tillNow);
    }
  };

  const getCommisions = async () => {
    setShimmer(true);

    const body = {
      access_token: partnerData && partnerData[0].access_token,
      start_date: formatDate(startOfMonth),
      end_date: formatDate(currentDate),
      partner_id: partnerData && partnerData[0].partner_id,
    };

    await httpApiCall({ api: "partner_commision", type: "POST", body })
      .then((data) => {
        if (data && !data.is_error) {
          setPayOut(data);
          setShimmer(false);
        }
      })
      .catch((error) => {
        setShimmer(false);

        console.error(
          "There was a problem with the commissions params:",
          error
        );
      });
  };

  const getListCommissions = async (limit?: any, type?: any, next?: any) => {
    setShimmer(true);

    const body = {
      access_token: partnerData && partnerData[0].access_token,
      start_date: formatDate(startOfMonth),
      end_date: formatDate(currentDate),
      limit: limit ? limit : 10,
      offset: next ? next : 0,
    };

    await httpApiCall({
      api: "partner_commision_listing",
      type: "POST",
      body,
    }).then(async (data) => {
      setShimmer(false);

      if (data && limit && type == 1) {
        setDocsData(data);
        if (data) {
          await exportXlsx(data);
        }
      } else if (data && limit && type === 2) {
        setDocsData(data);
        setTimeout(() => {
          if (csvLinkRef.current) {
            csvLinkRef.current.link.click();
          }
        }, 0);
      } else if (data && limit && type === 3) {
        setDocsData(data);
        if (data) {
          await downloadPDF(data);
        }
      } else {
        setListData(() => data);
        setRecords(data.total_records);
        setDocsData(data);
      }
    });
  };
  const rows =
    listData && listData.payments
      ? listData.payments.map((row: any, index: number) => [
          index + 1,
          row.partner_level,
          row.doctor_name,
          row.doctor_referral_code,
          row.contract_code,
          row.payment_type + (Number(row.amount_reversed) > 0 ? (' (' + allData.country_currency_info.currency[0]['display_logo'] + row.amount_reversed + ')') : ''),
          formatDate2(row.created),
          row.pay_to_partner
        ])
      : [];

  const handleDateRange = (item: any) => {
    setState(item.selection);
  };
  const rangeSelect = () => {
    // console.log(state, "state");
    setCurrentDate(state && state.endDate);
    setStartOfMonth(state && state.startDate);
    setShow(false);
    setState({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  const exportXlsx = (data: any) => {
    const dataArray = [
      ["Sr.	", "Tier","Business Name", "Business Code","Contract Code","Payment Type", "Transaction Date", "Commission Amount (" + allData.country_currency_info.currency[0]['display_logo'] + ')'],
    ];
    docsdata &&
      data?.payments?.forEach((item: any, i: any) => {
        const row = [
          i + 1,
          item.partner_level,
          item.doctor_name,
          item.doctor_referral_code,
          item.contract_code,
          item.payment_type+ (Number(item.amount_reversed) > 0 ? (' (' + allData.country_currency_info.currency[0]['display_logo'] + item.amount_reversed + ')') : ''),
          formatDate2(item.created),
          item.pay_to_partner
        ];
        dataArray.push(row);
      });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(dataArray);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "CredeePayoutReport" + ".xlsx");
    return;
  };
  const handlePageChange = (offset: number, type: any) => {
    // console.log(offset, "offset");
    if (type === "next") {
      setPage((prevPage) => prevPage + 1);
    } else if (type === "prev") {
      setPage((prevPage) => prevPage - 1);
    }
    let updatedPage = type === "next" ? page + 1 : page - 1;
    let data = (updatedPage - 1) * 10;
    getListCommissions("", "", data);
  };
  const downloadPDF = (data: any) => {
    const doc = new jsPDF();
    let amount: any = 0;
    if (data && data.payments) {
      data && data.payments.map((item: any) => amount += item.amount)
    }
    if (allData && allData.country_currency_info && allData.country_currency_info.currency && allData.country_currency_info.currency[0]) {
      amount = allData.country_currency_info.currency[0]['display_logo'] + Number(amount).toFixed(2);
    }
    // console.log(amount);
    const row =data && data.payments ? data.payments.map((row: any, index: number) => [
            index + 1,
            'Tier ' + row.partner_level,
            row.doctor_name,
            row.doctor_referral_code,
            row.contract_code,
            row.payment_type + (Number(row.amount_reversed) > 0 ? (' (' + allData.country_currency_info.currency[0]['display_logo'] + row.amount_reversed + ')') : ''),
            formatDate(row.created),
            row.pay_to_partner
          ])
        : [];
    // doc.addImage(logo, "PNG", 10, 10, 15, 15);
    doc.text('Payout statement', 10 , 10 );
    doc.line(75, 22, 75, 30, 'F')
    doc.line(165, 22, 165, 30, 'F')

    doc.setFontSize(8);
    doc.text('Name', 20 , 25 );
    doc.setFontSize(8);
    doc.text('Email Address', 80 , 25 );
    doc.setFontSize(8);
    doc.text('Phone', 170 , 25 );

    doc.setFontSize(10);
    doc.text(partnerData && partnerData.length && partnerData[0]['partner_name'], 20 , 30);
    doc.setFontSize(10);
    doc.text(partnerData && partnerData.length && partnerData[0]['partner_email'], 80 , 30 );
    doc.setFontSize(10);
    doc.text(partnerData && partnerData.length && partnerData[0]['partner_mobile_country_code'] + '-' +partnerData && partnerData.length && partnerData[0]['partner_mobile'], 170 , 30 );
    doc.setFontSize(8);
    doc.text('Total payment', 20 , 45 );
    doc.setFontSize(10);
    doc.text( amount, 20 , 50);
    autoTable(doc, {
      startY: 60,
      headStyles: { fillColor: [1, 61, 80] },
      head: [columns.map((item) => item.title)],
      body: row,
    });
  

    doc.save("CredeePayoutReport.pdf");
  };

  const callCommissionApi = async () => {
    if (grid) {
      getCommisions();
    }
  }

  return (
    <div className="commission right-wrapper">
      <div className="commission-header">
        <div className="left-head">
          <Dropdown className="dropdown-border">
            <Dropdown.Toggle variant="Secondary" id="dropdown-basic">
              {selectedChoice.name}
            </Dropdown.Toggle>

            {/* <Dropdown.Menu>
              {filter.map((value) => (
                <Dropdown.Item
                  key={value.id}
                  onClick={() => handleChoiceSelection(value)}
                >
                  {value.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu> */}
          </Dropdown>
          <div>
            <img
              src={!grid ? Tree : view}
              alt=""
              onClick={() => {
                setGrid(!grid);
                callCommissionApi()
                localStorage.setItem('commissionGridView', String(!grid));
              }}
              className="cursor"
              title={!grid ? "Grid View" : "Tree View"}
            />
          </div>
          <div>
            {grid &&
              listData &&
              listData.payments &&
              listData.payments.length ?  (
                <div className="d-flex align-items-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="Secondary"
                      id="dropdown-basic"
                      disabled={listData && listData.length == 0}
                    >
                      <img src={exports} alt="" className="cursor" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() =>
                          getListCommissions(listData.total_records, 1)
                        }
                      >
                        XLSX
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() =>
                          getListCommissions(listData.total_records, 2)
                        }
                      >
                        CSV
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <div
                    className="cursor"
                    onClick={() =>
                      getListCommissions(listData.total_records, 3)
                    }
                  >
                    <img src={Download} alt="" /> PDF
                  </div>
                </div>
              ) : null}
          </div>
        </div>

        <div className="badge--wrapper">
          <p className="badge__info">
            {/* <img src={Earn} alt="" />
             */}
             <svg className="me-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.75 15.9198H13.4C14.05 15.9198 14.59 15.3398 14.59 14.6398C14.59 13.7698 14.28 13.5998 13.77 13.4198L12.76 13.0698V15.9198H12.75Z" fill="#007094"/>
<path d="M11.9701 1.89992C6.45007 1.91992 1.98007 6.40992 2.00007 11.9299C2.02007 17.4499 6.51007 21.9199 12.0301 21.8999C17.5501 21.8799 22.0201 17.3899 22.0001 11.8699C21.9801 6.34992 17.4901 1.88992 11.9701 1.89992ZM14.2601 11.9999C15.0401 12.2699 16.0901 12.8499 16.0901 14.6399C16.0901 16.1799 14.8801 17.4199 13.4001 17.4199H12.7501V17.9999C12.7501 18.4099 12.4101 18.7499 12.0001 18.7499C11.5901 18.7499 11.2501 18.4099 11.2501 17.9999V17.4199H10.8901C9.25007 17.4199 7.92007 16.0399 7.92007 14.3399C7.92007 13.9299 8.26007 13.5899 8.67007 13.5899C9.08007 13.5899 9.42007 13.9299 9.42007 14.3399C9.42007 15.2099 10.0801 15.9199 10.8901 15.9199H11.2501V12.5399L9.74007 11.9999C8.96007 11.7299 7.91007 11.1499 7.91007 9.35992C7.91007 7.81992 9.12007 6.57992 10.6001 6.57992H11.2501V5.99992C11.2501 5.58992 11.5901 5.24992 12.0001 5.24992C12.4101 5.24992 12.7501 5.58992 12.7501 5.99992V6.57992H13.1101C14.7501 6.57992 16.0801 7.95992 16.0801 9.65992C16.0801 10.0699 15.7401 10.4099 15.3301 10.4099C14.9201 10.4099 14.5801 10.0699 14.5801 9.65992C14.5801 8.78992 13.9201 8.07992 13.1101 8.07992H12.7501V11.4599L14.2601 11.9999Z" fill="#007094"/>
<path d="M9.42188 9.37008C9.42188 10.2401 9.73187 10.4101 10.2419 10.5901L11.2519 10.9401V8.08008H10.6019C9.95188 8.08008 9.42188 8.66008 9.42188 9.37008Z" fill="#007094"/>
</svg>
            <span> Total Commission Received: </span>
            <span translate="no" className="color-green ms-1">
              <span>
                <CurrencyFormatter
                  amount={paymentData && paymentData.total_revenue ? paymentData.total_revenue : 0}
                />
              </span>
            </span>
          </p>
          <p className="badge__info">
            {/* <img src={Send} /> */}
            <svg className="me-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M18.8086 6.24998H20.1686C19.9786 5.97998 19.7786 5.72998 19.5686 5.47998L18.8086 6.24998Z" fill="#F77600" />
                                      <path d="M18.52 4.41982C18.27 4.20982 18.02 4.00982 17.75 3.81982V5.17982L18.52 4.41982Z" fill="#F77600" />
                                      <path d="M19.5795 5.47994L22.5295 2.52994C22.8195 2.23994 22.8195 1.75994 22.5295 1.46994C22.2395 1.17994 21.7595 1.17994 21.4695 1.46994L18.5195 4.41994C18.8995 4.74994 19.2495 5.10994 19.5795 5.47994Z" fill="#F77600" />
                                      <path d="M17.7517 3C17.7517 2.59 17.4117 2.25 17.0017 2.25C16.6017 2.25 16.2817 2.57 16.2617 2.96C16.7817 3.21 17.2817 3.49 17.7517 3.82V3Z" fill="#F77600" />
                                      <path d="M21.7519 7C21.7519 6.59 21.4119 6.25 21.0019 6.25H20.1719C20.5019 6.72 20.7919 7.22 21.0319 7.74C21.4319 7.72 21.7519 7.4 21.7519 7Z" fill="#F77600" />
                                      <path d="M12.75 14.7498H13.05C13.44 14.7498 13.75 14.3998 13.75 13.9698C13.75 13.4298 13.6 13.3498 13.26 13.2298L12.75 13.0498V14.7498Z" fill="#F77600" />
                                      <path d="M21.04 7.74C21.03 7.74 21.02 7.75 21 7.75H17C16.9 7.75 16.81 7.73 16.71 7.69C16.53 7.61 16.38 7.47 16.3 7.28C16.27 7.19 16.25 7.1 16.25 7V3C16.25 2.99 16.26 2.98 16.26 2.96C14.96 2.35 13.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.48 21.65 9.04 21.04 7.74ZM13.75 11.82C14.39 12.04 15.25 12.51 15.25 13.98C15.25 15.23 14.26 16.26 13.05 16.26H12.75V16.51C12.75 16.92 12.41 17.26 12 17.26C11.59 17.26 11.25 16.92 11.25 16.51V16.26H11.17C9.84 16.26 8.75 15.14 8.75 13.76C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H11.25V12.53L10.25 12.18C9.61 11.96 8.75 11.49 8.75 10.02C8.75 8.77 9.74 7.74 10.95 7.74H11.25V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V7.75H12.83C14.16 7.75 15.25 8.87 15.25 10.25C15.25 10.66 14.91 11 14.5 11C14.09 11 13.75 10.66 13.75 10.25C13.75 9.7 13.34 9.25 12.83 9.25H12.75V11.47L13.75 11.82Z" fill="#F77600" />
                                      <path d="M10.25 10.03C10.25 10.57 10.4 10.65 10.74 10.77L11.25 10.95V9.25H10.95C10.57 9.25 10.25 9.6 10.25 10.03Z" fill="#F77600" />
                                    </svg>
            <span> Total Upcoming Commission:</span>
            <span className="color-blue  ms-1" translate="no">
              <CurrencyFormatter
                amount={paymentData && paymentData.upcoming_revenue ? paymentData.upcoming_revenue : 0}
              />
            </span>
          </p>
        </div>
      </div>

      {show && (
        <Modal show={show} onHide={() => setShow(false)} className="date_modal">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div>
              {open && (
                <DateRangePicker
                  className="wrapper"
                  ranges={[state]}
                  onChange={(item: any) => handleDateRange(item)}
                  months={1}
                  showMonthArrow={true}
                  showMonthAndYearPickers={true}
                  showDateDisplay={true}
                  maxDate={new Date()}
                  minDate={new Date("2017-01-01")}
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex align-items-center justify-content-between">
            <Button className="" onClick={() => setShow(false)}>
              Close
            </Button>
            <Button onClick={rangeSelect}>Apply</Button>
          </Modal.Footer>
        </Modal>
      )}

      {!grid && payOut && payOut["hierarchy"]["length"] > 0 && !shimmer && (
        <Tier data={payOut}></Tier>
      )}
      <div className="p-4">
        {grid && !shimmer && (
          <Table callFunction={() => console.log('call from commission')}
            data={rows}
            columns={columns}
            allList={() => getListCommissions(listData?.total_records)}
          ></Table>
        )}

        {shimmer && (
          <div className="no_data_v2 text-center">
            <img src={dataLoading} alt="" />
          </div>
        )}

        {payOut &&
          payOut["hierarchy"] &&
          payOut["hierarchy"]["length"] == 0 &&
          !shimmer && <NoDataFound />}

        {grid && listData.total_records >= 10 && (
          <Pagination
            totalItems={listData.total_records}
            itemsPerPage={page}
            onPageChange={(offset: number, type: any) =>
              handlePageChange(offset, type)
            }
          ></Pagination>
        )}
        <div className="csvLink">
          <CSVLink
            data={dataArray}
            headers={docsdata?.payments?.forEach((item: any, i: any) => {
              const row = [
                i + 1,
                item.partner_level,
                item.doctor_name,
                item.doctor_referral_code,
                item.contract_code,
                item.payment_type+ (Number(item.amount_reversed) > 0 ? (' (' + allData.country_currency_info.currency[0]['display_logo'] + item.amount_reversed + ')') : ''),
                formatDate2(item.created),
                item.pay_to_partner
              ];
              dataArray.push(row);
            })}
            filename={"CredeePayoutReport.csv"}
            target={"_blank"}
            type="button"
            ref={csvLinkRef}
          ></CSVLink>
        </div>
      </div>
    </div>
  );
};

export default Commissions;
